/* eslint-disable no-param-reassign */
import { signal } from '@preact/signals-react';

const updateSignal = (signalToUpdate, newVal) => {
  if (!signalToUpdate) {
    throw new Error('Signal is not defined');
  }

  if (Array.isArray(signalToUpdate.value)) {
    signalToUpdate.value = [...newVal];
  } else if (typeof signalToUpdate.value === 'object') {
    signalToUpdate.value = {
      ...signalToUpdate.value,
      ...newVal,
    };
  } else {
    signalToUpdate.value = newVal;
  }

  return signal;
};

export const Signal = (initState) => {
  const rawSignal = signal(initState);
  rawSignal.update = (payload) => updateSignal(rawSignal, payload);
  rawSignal.reset = () => {
    rawSignal.value = initState;
  };
  return rawSignal;
};

export default Signal;
